import { colors } from '@/styles/GlobalStyle';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 340px;

  @keyframes fadeInRadio {
    from {
      opacity: 0;
      transform: scale(0);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes fadeInFields {
    from {
      opacity: 0;
      transform: translateY(40px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  form {
    display: flex;
    flex-direction: column;

    .cnpj {
      animation: fadeInFields 0.3s ease-in-out;
    }

    span {
      color: red;
      font-size: 13px;
      display: block;
      margin-top: 5px;
    }

    > div.radio {
      display: flex;
      flex-direction: column;

      h3 + label {
        margin-top: 8px;
      }

      label {
        font-size: 16px;
        font-family: 'Sora';
        color: ${colors.gray700};
        position: relative;
        padding: 10px 0;
        padding-left: 28px;

        width: fit-content;
        cursor: pointer;

        display: flex;
        align-items: center;

        :last-child {
          margin-top: 3px;
        }
      }
      input[type='radio'] {
        position: absolute;
        opacity: 0;
        left: -999999999999px;
      }

      input[type='radio'] + label::before {
        content: '';
        width: 16px;
        height: 16px;
        border: 2px solid ${colors.gray600};
        position: absolute;
        left: 0;
        border-radius: 50%;

        transition: 0.2s;
      }

      input[type='radio']:checked + label::before {
        content: '';
        width: 16px;
        height: 16px;
        border-color: ${colors.orange300};
        position: absolute;
        left: 0;
        border-radius: 50%;

        transition: 0.2s;

        transition: border-color 0.2s;
      }

      input[type='radio']:checked + label::after {
        content: '';
        width: 10px;
        height: 10px;
        position: absolute;
        background: ${colors.orange300};
        left: 5px;
        border-radius: 50%;

        animation: fadeInRadio 0.3s;
      }

      h3 {
        margin-top: 30px;
        font-size: 16px;
        color: black;
        font-weight: 700;
      }
    }
  }

  input:not([type='checkbox']):not([type='radio']) {
    margin-top: 30px;

    padding: 10px 16px;
    border-radius: 13px;
    height: 60px;
    width: 100%;

    border: 1px solid rgba(0, 0, 0, 0.3);
    outline: none;
    transition: all 0.2s;

    color: ${colors.gray600};
    font-size: 16px;
    font-family: 'Sora';
    line-height: 24px;

    ::-webkit-input-placeholder {
      color: ${colors.gray600};
    }

    :-ms-input-placeholder {
      color: ${colors.gray600};
    }

    ::placeholder {
      color: ${colors.gray600};
    }

    :focus {
      border: 1px solid ${colors.orange300}ee;
    }
  }

  button {
    margin-top: 20px;
    width: 100%;
    max-width: 127px;
    height: 60px;
    color: white;
    background: ${colors.orange300};
    border: none;
    outline: none;
    border-radius: 13px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;

    cursor: pointer;

    transition: 0.3s;

    :hover {
      background: ${colors.orange400};
    }
  }
`;
